<template>
    <div class="d-flex flex-column">
        <div v-for="(phone, i) in values" :key="i" class="phone-number-editor mb-1">
            <div class="input-group">
                <provision-phone-number v-model="phone.number" class="form-control w-auto">
                    <input type="checkbox" v-model="phone.external" class="form-check-input position-absolute me-2 end-0" title="Check for an external number">
                </provision-phone-number>
                <select class="form-control w-auto" v-model="phone.language">
                    <option v-for="lang in languages" :key="lang.value" :value="lang.value">{{ lang.text }}</option>
                </select>
                <button class="btn btn-outline-danger" @click.prevent="remove(phone)" title="Remove"><fa class="fa-minus"></fa></button>
            </div>
            <div class="input-group">
                <select class="form-control" v-model="phone.voice" @input="voiceChanged">
                    <option v-for="voice in voicesFor(phone.language)" :key="voice.value" :value="voice.value">{{ formatVoice(voice) }}</option>
                </select>
                <button class="btn btn-outline-primary" title="Play sample"
                        :disabled="!phone.voice"
                        @click.prevent="playSample(phone.voice)">
                    <fa v-if="!playing" class="fa-play fa-fw"></fa>
                    <fa v-if="playing" class="fa-pause fa-fw"></fa>
                </button>
            </div>
        </div>
        <button class="btn btn-outline-success" @click.prevent="add"><fa class="fa-plus"></fa> Add</button>
    </div>
</template>
<script>
    import { PickList } from '../components/DataGrid/AutoForm';
    import ProvisionPhoneNumber from './ProvisionPhoneNumber';

    let audio = null;

    export default {
        props: {
            col: { type: Object },
            model: { type: Object },
            modelValue: { type: Array },
        },
        emits: ['update:model-value'],
        data: function () {
            return {
                languages: PickList.languages,
                playing: false,
                values: []
            };
        },
        components: {
            ProvisionPhoneNumber
        },
        computed: {
        },
        methods: {
            add() {
                this.values.push({ id: null, number: '', enabled: true, language: 'en-US' });
            },
            formatVoice(voice) {
                let gender = voice.meta == 'F' ? 'Female' : 'Male';
                return `${voice.text} (${gender}, ${voice.lang})`;
            },
            playSample(voice) {
                const vm = this;
                if (vm.playing) {
                    audio?.pause();
                    return;
                }
                audio = new Audio(`https://files.fumbl.ai/public/audio/samples/${voice}.ogg`);
                audio.addEventListener('canplay', () => { audio.play(); });
                audio.addEventListener('playing', () => { vm.playing = true; });
                audio.addEventListener('pause', () => { vm.playing = false; });
                audio.addEventListener('ended', () => { vm.playing = false; });
            },
            remove(phone) {
                let idx = this.values.indexOf(phone);
                if (idx >= 0) this.values.splice(idx, 1);
            },
            updateValue() {
                this.$emit('update:model-value', this.values);
            },
            voiceChanged() {
                audio?.pause();
            },
            voicesFor(language) {
                const langName = PickList.languages.find(l => l.value === language)?.text ?? '';
                let list = PickList.voices.filter(v => v.lang.includes(langName));
                return list.length ? list : PickList.voices;
            }
        },
        watch: {
            modelValue: {
                handler(values) {
                    this.values = values ?? [];
                },
                immediate: true,
            },
            values: {
                handler() {
                    this.updateValue();
                },
                deep: true,
            }
        }
    }
</script>